<template>
  <el-dialog
    v-drag
    title="新增跟进记录"
    :visible.sync="dialogVisible"
    width="690px"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
    top="3vh"
  >
    <div class="content">
      <el-form ref="form" class="form" :model="form" :rules="rules">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="mblSendWayId" label="派送方式">
              <el-select
                v-model="form.mblSendWayId"
                style="width: 315px"
                placeholder="请选择类别"
              >
                <el-option
                  v-for="(item, $index) in sandWayOptions"
                  :key="$index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="type" label="类型">
              <el-select
                v-model="form.type"
                style="width: 315px"
                placeholder="请选择类型"
              >
                <el-option
                  v-for="(item, $index) in config.sandWayTypeOptions"
                  :key="$index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item prop="remark" label="描述">
            <el-input v-model="form.remark" placeholder="请输入描述" style="width: 650px;" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item prop="remark" label="上传附件">
            <div class="upload-content">
              <el-upload
                action="#"
                :show-file-list="false"
                :http-request="httpRequest"
              >
                <div class="upload">
                  <img src="@/assets/images/bill/load.png" alt="" />
                  选择文件上传
                </div>
              </el-upload>
              <div v-if="file.name" class="file">
                <div style="display: flex;">
                  <div class="file-progress">
                    <el-progress type="circle" :stroke-width="4" :percentage="file.percent" :width="40"></el-progress>
                  </div>
                  <div class="file-des">
                    <p class="file-name">{{ file.name }}</p>
                    <p class="file-size">{{ file.size | formatSize }} mb</p>
                  </div>
                </div>
                <div class="opt">
                  <i class="el-icon-delete" @click="deleteFile()" />
                </div>
              </div>
            </div>
          </el-form-item>
        </el-row>
        <div class="table">
          <div class="search">
            <span class="label">选择订单</span>
            <el-input
              v-model="text"
              style="width: 240px;"
              placeholder="请输入内容"
              prefix-icon="el-icon-search">
            </el-input>
          </div>
          <BaseTable
            style="margin-top: 10px;"
            height="360"
            :tableData="{...tableData, columns}"
            :isPager="false"
            :border="true"
            @handleSelectionChange="handleSelectionChange"
          ></BaseTable>
        </div>
        <div class="table-footer">
          <span>已选择  <span style="color: rgba(35, 149, 243, 1);">{{ selection.length }}</span>  项</span>
        </div>
      </el-form>
    </div>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取 消</div>
      <div class="ok flex_c_c" @click="ok('form')">确 定</div>
    </span>
  </el-dialog>
</template>

<script>
import { getMBLSendWay, getOrderDetailPages, addFMSMBLFollowUp } from '@/api/bill'
const BaseTable = () => import('@/components/table/BaseTable')
import config from '@/utils/config'
export default {
  components: { BaseTable },
  filters: {
    formatSize: function(num) {
      return (num / 1024 / 1024).toFixed(2)
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      config,
      sandWayOptions: [],
      form: {
        mblSendWayId: '',
        remark: '',
        type: ''
      },
      rules: {
        mblSendWayId: [{ required: true, message: '请选择派送方式', trigger: 'change' }],
        type: [{ required: true, message: '请选择类型', trigger: 'change' }],
        remark: [{ required: true, message: '请输入描述', trigger: 'blur' }]
      },
      tableData: {
        fileds: [
          {
            filed: 'referenceNumber',
            label: '参考单号',
            width: '',
            resizable: true
          },
          {
            filed: 'masterTrackingNumber',
            label: '主单号',
            width: '',
            resizable: true
          },
          {
            filed: 'trackingNumber',
            label: '子单号',
            resizable: true
          }
        ],
        columns: [],
        total: 0,
        mutiCheck: true
      },
      selection: [],
      text: '',
      file: {
        percent: 0,
        name: '',
        size: 0
      }
    }
  },
  computed: {
    columns: function() {
        if (!this.text) {
            return this.tableData.columns
        }
        return this.tableData.columns.filter(item => {
            return item.referenceNumber === this.text.toUpperCase() ||
            item.masterTrackingNumber === this.text.toUpperCase() ||
            item.trackingNumber === this.text.toUpperCase() ||
            item.referenceNumber.split('-') === this.text.toUpperCase()
        })
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.getList()
        this.getOrder()
      }
    }
  },
  created() {
    // this.getList()
    // this.getOrder()
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    async getList() {
      try {
        const res = await getMBLSendWay({
          mblId: this.rowData.id
        })
        if (res.success) {
          this.sandWayOptions = res.data.map((item) => {
            return {
              value: item.id,
              label: `${item.typeName} ${item.code ? `- ${item.code}` : ''}`
            }
          })
        }
        console.log(res)
      } catch (error) {
        console.log(error)
      }
    },
    async getOrder() {
        try {
         const params = {
            pageIndex: 1,
            pageSize: 1000,
            queryParam: {
                id: this.rowData.id
            }
        }
            const result = await getOrderDetailPages(params)
            if (result.success) {
                this.tableData.columns = result.data.list
                this.tableData.total = result.data.total
            } else {
                this.$message.error(result.errorMessage)
            }
        } catch (error) {
            console.log(error)
        }
    },
    ok(formName) {
      if (this.selection.length === 0) {
        this.$message.error('勾选订单')
        return ''
      }
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
            try {
                const trackingNumber = this.selection.map(a => a.trackingNumber)
                const formData = new FormData()
                if (this.file.name) {
                  formData.set('file', this.file)
                }
                formData.set('input.mblSendWayId', this.form.mblSendWayId)
                formData.set('input.remark', this.form.remark)
                formData.set('input.type', this.form.type)
                trackingNumber.forEach((item, index) => {
                  formData.set(`input.trackingNumber[${index}]`, item)
                })
                const res = await addFMSMBLFollowUp(formData)
                if (res.data.success) {
                    this.file = {
                      ...this.file,
                      percent: 100
                    }
                    this.$message.success('新增成功')
                    this.$emit('ok')
                } else {
                    this.$message.error(res.data.errorMessage)
                }
            } catch (error) {
                console.log(error)
            }
          console.log(valid)
        }
      })
    },
    handleSelectionChange(selection) {
        this.selection = selection
    },
    httpRequest({ file }) {
      this.file = file
      console.log('res', file)
    },
    deleteFile() {
      this.file = {
        percent: 0,
        name: '',
        size: 0
      }
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  height: auto;
  margin: 0 auto;
  .form {
    width: 100%;
    margin: 0 auto;
    &:deep(.el-form-item__label) {
        line-height: 30px;
        font-size: 14px;
      }
      &:deep(.el-form-item) {
        margin-bottom: 10px;
        position: relative;
      }
  }
  .upload-content {
    margin-top: 30px;
    display: flex;
  }
  .upload {
    width: 140px;
    height: 40px;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid  rgb(18,88,188);
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color:  rgb(18,88,188);
    box-sizing: border-box;
    cursor: pointer;
    line-height: 40px;
    img {
      vertical-align: -4px;
    }
  }
  .file {
    width: 282px;
    height: 40px;
    background: #FFFFFF;
    opacity: 1;
    display: flex;
    justify-content: space-between;
  }
  .file-icon {
    margin: 14px 0 14px 8px;
    width: 32px;
  }
  .file-progress {
    width: 40px;
    margin-left: 8px;
  }
  .file-des {
    margin: 0px 10px;
    width: 200px;
    height: 40px;
  }
  .file-name {
    width: 100%;
    height: 19px;
    font-size: 12px;
    font-weight: 400;
    color: #666666;
    line-height: 19px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .file-size {
    width: 100%;
    height: 19px;
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    line-height: 19px;
  }
  .opt {
    width: 20px;
    height: 40px;
    font-size: 20px;
    line-height: 40px;
    color: #999999;
    margin-right: 10px;
    cursor: pointer;
  }
  .table {
    width: 100%;
    margin: 20px auto 0;
    height: 410px;
    .search {
       height: 40px;
       width: 100%;
       display: flex;
       justify-content: space-between;
    }
    .label {
        margin-top: 20px;
        width: 56px;
        height: 20px;
        font-size: 14px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
    }
  }
  .table-footer {
    width: 76px;
    height: 20px;
    font-size: 12px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    line-height: 20px;
    margin-top: 10px;
  }
}
.footers {
  width: 100%;
  display: flex;
  justify-content: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-right: 16px;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background:  rgb(18,88,188);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    cursor: pointer;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
}
/deep/ .el-dialog__body {
  padding: 0px 20px 40px;
}
/deep/ .el-dialog__header {
  border: 0;
}
</style>
